import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const SearchContext = createContext();

export const SearchProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  const toggleModal = useCallback(() => {
    setIsOpen(prev => !prev);
  }, []);

  // Keyboard shortcut effect
  useEffect(() => {
    const handleKeyDown = (event) => {
      // Ctrl/Cmd + K to open search
      if ((event.ctrlKey || event.metaKey) && event.key === 'k') {
        event.preventDefault();
        openModal();
      }
      
      // Escape to close
      if (event.key === 'Escape' && isOpen) {
        closeModal();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, openModal, closeModal]);

  return (
    <SearchContext.Provider value={{
      isOpen,
      openModal,
      closeModal,
      toggleModal
    }}>
      {children}
    </SearchContext.Provider>
  );
};

export const useSearchModal = () => {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error('useSearchModal must be used within a SearchProvider');
  }
  return context;
};